export const contactTypesSelector = state => state.contactReducer.contactTypes;

export const workTypesSelector = state => state.contactReducer.workTypes;

export const loadingContactsSelector = state => state.contactReducer.loadingContacts;

export const contactListSelector = state => state.contactReducer.contactList;
